<template>
  <nav
    class="navbar show navbar-vertical h-lg-screen navbar-expand-lg px-0 py-3 navbar-light bg-white border-bottom border-bottom-lg-0 border-end-lg"
    id="sidebar"
  >
    <div class="container-fluid">
      <button
        class="navbar-toggler ms-n2"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#sidebarCollapse"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

    <router-link
      class="logo navbar-brand py-lg-2 mb-lg-5 px-lg-6 me-0 d-flex align-items-center"
      :to="{ name: 'home' }"
    >
      <div style="padding:0;width:auto;">
        <img style="height:2.875rem;padding:0;" :src="imgUrls.primary" alt="PGS-hub Logo" />
      </div>
      <div class="prs ms-3">
        <p class="mb-0 fw-bold">PGS-hub</p>
      </div>
    </router-link>

      <div class="navbar-user d-lg-none">
        <div class="dropdown">
          <a href="#" id="sidebarAvatar" data-bs-toggle="dropdown">
            <div class="avatar-parent-child" :class="isLoginClass" style="border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;">
              <i class="bi bi-person-fill text-white fs-5"></i>
              <span v-if="isAuthed" class="avatar-child avatar-badge bg-success"></span>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <div v-if="isAuthed" class="dropdown-header">
              <span class="d-block text-sm text-muted">Logged in as</span>
              <span class="d-block text-heading font-semibold">{{ displayName }}</span>
            </div>
            <router-link class="dropdown-item" v-for="(menu, index) in userMenus" :to="menu.path" :key="index">
              <i class="bi me-2" :class="menu.addClass"></i>{{ menu.val }}
            </router-link>
            <hr class="dropdown-divider" />
            <a v-if="isAuthed" href="#" class="dropdown-item text-danger" @click.prevent="logout">
              <i class="bi bi-box-arrow-left me-2"></i>Logout
            </a>
            <router-link v-else class="dropdown-item" to="/login">
              <i class="bi bi-box-arrow-in-right me-2"></i>Login
            </router-link>
          </div>
        </div>
      </div>

      <div class="collapse navbar-collapse" id="sidebarCollapse">
        
        <div class="px-6 mb-8 mt-4">
          <div class="p-4 bg-light rounded-4 border border-2 border-dashed">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <h6 class="text-uppercase text-muted ls-wide font-semibold text-xs mb-0">Analysis Pipeline</h6>
              <span class="badge bg-soft-primary text-primary rounded-pill text-xs px-2 fw-bold">
                Step {{ currentStepNumber }} / 4
              </span>
            </div>
            
            <div class="pipeline-steps">
              <div v-for="(step, idx) in pipelineSteps" :key="idx" 
                   class="d-flex align-items-start mb-3 last-child-mb-0">
                <div class="step-indicator me-3">
                  <div class="step-line" v-if="idx !== pipelineSteps.length - 1"></div>
                  <div class="step-dot" :class="getStepStatusClass(idx)">
                    <i v-if="currentStepNumber > (idx + 1)" class="bi bi-check-lg"></i>
                    <span v-else>{{ idx + 1 }}</span>
                  </div>
                </div>
                <div class="step-content">
                  <span class="d-block text-xs font-bold transition-all" 
                        :class="currentStepNumber === (idx + 1) ? 'text-primary' : 'text-muted'">
                    {{ step.title }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="px-2">
          <h6 class="navbar-heading text-xs text-muted text-uppercase ls-wide font-semibold px-4 mb-2">Resources</h6>
          <ul class="nav nav-sm flex-column mb-6">
            <li class="nav-item" v-for="(nav, index) in navigations.slice(0, 2)" :key="index">
              <router-link :to="nav.path" class="nav-link" active-class="active-link">
                <i class="bi mbi" :class="nav.sign"></i>
                {{ nav.name }}
              </router-link>
            </li>
          </ul>

          <h6 class="navbar-heading text-xs text-muted text-uppercase ls-wide font-semibold px-4 mb-2">Computation</h6>
          <ul class="nav nav-sm flex-column">
            <li class="nav-item" v-for="(nav, index) in navigations.slice(2)" :key="index">
              <router-link :to="nav.path" class="nav-link" active-class="active-link">
                <i class="bi mbi" :class="nav.sign"></i>
                {{ nav.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="mt-auto"></div>

        <div class="my-4 px-lg-6 position-relative">
          <div class="dropup w-full">
            <button
              class="d-flex w-full py-3 ps-3 pe-4 align-items-center shadow-sm rounded-3 border-0 transition-all"
              :class="isLoginClass"
              type="button"
              data-bs-toggle="dropdown"
            >
              <span class="me-3 d-flex align-items-center justify-content-center bg-white bg-opacity-20 rounded-circle" style="width: 32px; height: 32px;">
                <i class="bi bi-person-fill text-white"></i>
              </span>
              <span class="flex-fill text-start text-sm font-semibold overflow-hidden text-nowrap text-white">
                {{ displayName }}
              </span>
              <i class="bi bi-chevron-expand text-white text-opacity-70"></i>
            </button>

            <div class="dropdown-menu dropdown-menu-end w-full shadow-lg">
              <div class="dropdown-header">
                <span class="d-block text-sm text-muted mb-1">Account Status</span>
                <span class="d-block text-heading font-semibold">{{ isAuthed ? 'Online' : 'Guest' }}</span>
              </div>
              <div class="dropdown-divider"></div>
              <div v-if="isAuthed">
                <router-link class="dropdown-item" v-for="(menu, index) in userMenus" :key="index" :to="menu.path">
                  <i class="bi me-3" :class="menu.addClass"></i>{{ menu.val }}
                </router-link>
              </div>
              <router-link v-else class="dropdown-item" to="/login">
                <i class="bi bi-box-arrow-in-right me-3"></i>Sign In
              </router-link>
              <div class="dropdown-divider"></div>
              <a v-if="isAuthed" class="dropdown-item text-danger" href="#" @click.prevent="logout">
                <i class="bi bi-box-arrow-left me-3"></i>Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Account } from "@/api"

export default {
  name: "SidebarItem",
  data() {
    return {
      imgUrls: { primary: process.env.BASE_URL + 'img/logos/PGS-hub.png' },
      pipelineSteps: [
        { title: "Step 1: GWAS Statistics", step: 1 },
        { title: "Step 2: LD Reference", step: 2 },
        { title: "Step 3: PGS Calculation", step: 3 },
        { title: "Step 4: Job & Results", step: 4 },
      ],
      navigations: [
        { name: "GWAS Statistics", sign: "bi-upload", path: "/gwasreference" },
        { name: "LD Reference", sign: "bi-upload", path: "/ldreference" },
        { name: "Single Ancestry", sign: "bi-terminal", path: "/analysis" },
        { name: "Multiple Ancestries", sign: "bi-terminal", path: "/multipleAncestries" },
        { name: "Jobs & Explorer", sign: "bi-cpu", path: "/statistics" },
      ],
      userMenus: [
        { val: "Settings", path: "/settings", addClass: "bi-gear" },
      ],
    }
  },
  computed: {
    isAuthed() { return Account.isAuthenticated(); },
    displayName() {
      if (!this.isAuthed) return "Guest User";
      const user = Account.getUser();
      return user?.email ||user?.name || user?.username ||  "User";
    },
    isLoginClass() {
      return this.isAuthed ? "bg-primary" : "bg-secondary";
    },
    // 直接根据当前路由元信息判断步骤
    currentStepNumber() {
      // 这里的 0 是兜底值，如果 meta.step 不存在
      return this.$route.meta?.step || 0;
    }
  },
  methods: {
    getStepStatusClass(idx) {
      const stepNum = idx + 1;
      if (this.currentStepNumber === stepNum) return 'active';
      if (this.currentStepNumber > stepNum) return 'complete';
      return '';
    },
    async logout() {
      try {
        await Account.logout();
        this.$router.push("/login");
      } catch (e) {
        console.error("Logout failed", e);
      }
    }
  }
}
</script>

<style scoped>
/* 保持原有的样式不变 */
.step-indicator { position: relative; display: flex; flex-direction: column; align-items: center; }
.step-line { position: absolute; top: 24px; width: 2px; height: 20px; background-color: #e2e8f0; }
.step-dot { width: 24px; height: 24px; border-radius: 50%; border: 2px solid #e2e8f0; background: white; display: flex; align-items: center; justify-content: center; font-size: 10px; font-weight: bold; color: #94a3b8; z-index: 1; transition: all 0.3s ease; }
.step-dot.active { border-color: #796cff; color: #796cff; box-shadow: 0 0 0 3px rgba(121, 108, 255, 0.2); }
.step-dot.complete { background-color: #796cff; border-color: #796cff; color: white; }
.last-child-mb-0:last-child { margin-bottom: 0 !important; }
.logo { color: #796cff; text-decoration: none; }
.prs p { font-size: 1.25rem; letter-spacing: -0.02em; }
.bg-primary { background-color: #796cff !important; }
.bg-secondary { background-color: #64748b !important; }
.bg-soft-primary { background-color: rgba(121, 108, 255, 0.1); }
.nav-link { padding: 0.6rem 1rem; border-radius: 0.5rem; margin: 0.125rem 0.5rem; font-size: 0.875rem; color: #475569; display: flex; align-items: center; }
.nav-link i { margin-right: 0.75rem; font-size: 1.1rem; opacity: 0.7; }
.nav-link:hover { background-color: #f1f5f9; color: #796cff; }
.active-link { font-weight: 700 !important; color: #796cff !important; background-color: rgba(121, 108, 255, 0.08); }
.transition-all { transition: all 0.2s ease; }
.border-dashed { border-style: dashed !important; }
</style>